import { Suspense, lazy } from "react";

import { Layout } from "../../features/layout";

const Content = lazy(() => import("./AboutContent"));

export function AboutPage() {
  return (
    <Layout>
      <Suspense fallback={null}>
        <Content />
      </Suspense>
    </Layout>
  );
}
